import React, { useEffect, useState } from "react";
import DataGrid from "../datagrid/DataGrid.js";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { wrap } from "lodash";

const TableChart = ({
  data,
  item,
  setOpenDeleteChartModal,
  setOpenEditChartModal,
  currPage,
  setChartSlug,
  setDashChartSlug,
}) => {
  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noDataFound, setNoDataFound] = useState("");

  useEffect(() => {
    if (data === "fetching") {
      setIsLoading(true);
      setNoDataFound("");
    } else if (data.length > 0) {
      setIsLoading(false);
      const gradeOrder = ["C-", "C", "C+", "B-", "B", "B+", "A-", "A", "A+"];
      setColumns(
        item.data_sequence.map((column) => ({
          name: column.replace(/_/g, " ").toUpperCase(),
          selector: (row) => row[column],
          sortable: (data.length > 1 ? true : false),
          reorder: true,
          wrap: true,
          //width:"60px",
          sortFunction: (rowA, rowB) => {
            const valA = rowA[column];
            const valB = rowB[column];

            // Check if both values exist in gradeOrder
            const indexA = gradeOrder.indexOf(valA);
            const indexB = gradeOrder.indexOf(valB);

            if (indexA !== -1 && indexB !== -1) {
              return indexA - indexB; // Sort by predefined order
            } else if (indexA !== -1) {
              return -1; // If A is in the order but B isn't, A comes first
            } else if (indexB !== -1) {
              return 1; // If B is in the order but A isn't, B comes first
            } else if (typeof valA === "string" && typeof valB === "string") {
              return valA.localeCompare(valB); // Alphabetical sorting
            } else if (typeof valA === "number" && typeof valB === "number") {
              return valA - valB; // Numeric sorting
            } else {
              return 0; // Default fallback
            }
          },
        }))
      );
      setTableData(data);
    } else {
      setIsLoading(false);
      setNoDataFound("No data found");
    }
  }, [data, item]);

  const RowDetails = ({ data }) => (
    <div className="m-4">
      <div className="d-flex align-items-center border-bottom mb-2">
        <h6 className="mb-1 me-1">Additional Details of {data?.name}</h6>
      </div>
      <a
        target="_blank"
        className="ps-2"
        title={data.website}
        style={{ cursor: "pointer" }}
        href={data.website}
        rel="noreferrer"
      >
        <FontAwesomeIcon className="me-2" icon={faGlobe} />
        {data.website}
      </a>
      <div className="mt-2 ps-4 bg-light border rounded">
        {`Desktop + Mobile : ${data.desktop + data.mobile}`}
      </div>
    </div>
  );

  const handleShowMoreOptions = (event) => {
    const options = document.querySelectorAll(
      ".more-options-wrapper .more-options"
    );
    const current = event.target
      .closest(".more-options-wrapper")
      .querySelector(".more-options");
    options.forEach((opt) => (opt.style.display = "none"));
    current.style.display = current.style.display === "none" ? "block" : "none";
  };

  return (
    <>
      {noDataFound ? (
        <div className="chart-title" style={{ padding: "12px" }}>
          {noDataFound}
        </div>
      ) : isLoading ? (
        <i
          className="fa-solid fa-spinner fa-spin-pulse"
          style={{ marginTop: "20px" }}
        ></i>
      ) : (
        <>
          {/* {item?.title && (
            <div className="chart-header">
              <div className="chart-title">{item.title}</div>
              
            </div>
          )} */}
          {currPage === "manage_layout" && (
            <div
              className="text-right more-options-wrapper"
              style={{
                fontSize: "15px",
                marginTop: "-30px",
                marginBottom: "25px",
              }}
            >
              <button
                type="button"
                onClick={handleShowMoreOptions}
                title="More"
                className="btn-more-options"
              >
                <i className="fa-solid fa-ellipsis-vertical not-0"></i>
              </button>
              <div className="more-options" style={{ display: "none" }}>
                <button
                  type="button"
                  onClick={() => {
                    setOpenEditChartModal(true);
                    setChartSlug(item.cht);
                    setDashChartSlug(item.dash_chrt);
                  }}
                >
                  <i className="fa-solid fa-pencil" aria-hidden="true"></i>{" "}
                  <span>Edit Chart</span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setOpenDeleteChartModal(true);
                    setChartSlug(item.cht);
                    setDashChartSlug(item.dash_chrt);
                  }}
                >
                  <i className="fas fa-trash-alt"></i> <span>Delete Chart</span>
                </button>
              </div>
            </div>
          )}
          <div className="table-chart-container">
            <div className="table-chart">
              <DataGrid
                columns={columns}
                data={tableData}
                pagination={item?.pagination_per_page || 30}
                title={item?.title}
                options={{
                  headerBgColor: "#fec71e",
                  headerColor: "black",
                  headerFontSize: 11,
                  cellFontSize: 11,
                  showHeader: true,
                  export: true,
                  headerTitle: item?.title,
                  filter: true
                }}
              />

              <div
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  marginTop: "10px", // Adds spacing from the ReactFlow container
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  fontSize: "14px",
                  textAlign: `${item?.legend_align}`,
                  color: "#666"
                }}
                dangerouslySetInnerHTML={{ __html: item?.legend}}
              >
                
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TableChart;
